/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface DebugData {
  /** The UUID of the debug data */
  uuid: string;
  /** The username associated with the debug data */
  username: string;
  /**
   * The date and time when the debug data was created
   * @format date-time
   */
  date: string;
  /** The sample ID associated with the debug data */
  sample: string;
  /** The practice mode ID associated with the debug data */
  practiceModeId: number;
  autosaved?: boolean;
  autoRemovable?: boolean;
  /** A list of event objects */
  events: {
    /** Adjust the type based on your actual data structure */
    noteOff?: object;
    /** Adjust the type based on your actual data structure */
    noteOn?: object;
    position?: {
      measureIndex?: number;
      measureStart?: number;
      measureOffset?: number;
    };
    midiMessages?: {
      data?: any[];
      dataBytes?: any[];
      message?: object;
    };
  }[];
}

export interface Fragment {
  /** The UUID of user owner */
  uuid: string;
  /** Identifier of sample related to fragment */
  sampleId: string;
  /** Name selected by user for the fragment */
  name: string;
  /** Hand used for fragment. Can either be 'left' or 'right' */
  hand: "left" | "right";
  /** Range of coordinates for the fragment, from left to right */
  range: {
    startCoord?: Coord;
    endCoord?: Coord;
  };
}

export interface NoteCustomAttributes {
  /** UUID */
  uuid?: string;
  /** The index of measure */
  measureIndex: number;
  /** The index of the note in its XML parent */
  indexInXmlParent: number;
  /** Visual x offset of note */
  xOffset?: number;
  /** For which hand this note */
  hand?: number;
  accid?: string;
  fing?: number;
  fingPos?: string;
  /** @format date-time */
  modifiedAt?: string;
  /** A history of changes to the note */
  history?: {
    uuid?: string;
    measureIndex?: number;
    indexInXmlParent?: number;
    xOffset?: number;
    hand?: number;
    /** @format date-time */
    modifiedAt?: string;
  }[];
}

export interface Sample {
  /** Id of sample from mongodb */
  _id: string;
  uploader?: {
    /** id of uploader - user */
    sub?: string;
    /** name of uploader -user */
    name?: string;
  };
  /** Should this sample have public access? */
  public?: boolean;
  /** Is Sample is now in moderation before it's public release? */
  inModeration?: boolean;
  /** Unique identifier like id (12 char string) */
  identifier: string;
  /** Sample is now in public domain */
  moderationApproved?: boolean;
  /** initial filename of musicxml */
  musicxmlFilename: string;
  /** Path to the MusicXML file. */
  musicxmlPath: string;
  /** Initial filename of audio file */
  audioFilename?: string;
  /** Path to the audio file. */
  audioPath?: string;
  /** Path to the cache file. */
  cachePath?: string;
  /** Initial filename of midi */
  midiFilename?: string;
  /** Path to the MIDI file. */
  midiPath?: string;
  /** Path to the WebP image file. */
  webpPath?: string;
  category: Category;
  metadata: {
    title: {
      /** Title of the sample in English. */
      en?: string;
      /** Title of the sample in Russian. */
      ru?: string;
    };
    author: Author;
    /** Indicates whether MIDI data is loaded. */
    midiLoaded: boolean;
    /** Manual changelog of musicxml. */
    manualChangelog?: string;
    /** Number of wrong notes in the MIDI data. */
    midiWrongNotesCount: number;
  };
  /** Custom attributes for notes */
  notesCustomAttributes?: NoteCustomAttributes[];
}

export interface Author {
  /** @format objectId */
  _id: string;
  en: string;
  ru: string;
}

export interface Category {
  /** @format objectId */
  _id: string;
  en: string;
  ru: string;
}

export interface GameStats {
  _id?: string;
  userId: string;
  sampleId: string;
  stats?: {
    lastSaved?: {
      measureIndex?: number;
      currentScore?: number;
      multiplier?: number;
      /** @format date-time */
      updatedAt?: string;
    };
    highestScore?: number;
  };
}

export interface UserReport {
  /** Unique identifier for the user. */
  uuid: string;
  /** Total accumulated time spent by the user. */
  accumulatedTime: number;
  /** Start of the week timestamp. */
  weekStartAt: number;
  /** Timestamp of the last event recorded. */
  lastEventAt: number;
  /** Sample identifier. */
  sampleId: string;
}

export interface KeyEvent {
  /** Unique identifier for the key event. */
  uuid: string;
  /** Identifier of sample. */
  sampleId: string;
  /** Timestamp of the key event. */
  timestamp: number;
}

export interface Peer {
  /** ID of the WebSocket connection */
  websocketId?: string;
  /** ID of the peer */
  peerId?: string;
}

export interface Coord {
  /** The measure index */
  measure?: number;
  /** The offset within the measure */
  offset?: number;
  /** The x coordinate */
  xCoord?: number;
  /** The y coordinate */
  yCoord?: number;
  /** The absolute time in milliseconds */
  absoluteTime?: number;
  /**
   * The vertical position of the chord
   * @default 0
   */
  chord?: number;
}

export interface StatRecord {
  /** MongoDB ObjectId of the stat record */
  _id?: string;
  /** User ID from Keycloak auth token */
  userId: string;
  /** MongoDB ObjectId of the sample */
  sampleId: string;
  /** Sample title at time of practice */
  title: string;
  /** Sample author/composer at time of practice */
  author: string;
  /** Time spent practicing in milliseconds */
  durationMs: number;
  /** Total notes pressed during practice */
  totalNotes: number;
  /** Notes that matched expected */
  correctNotes: number;
  /** Notes that didn't match expected */
  wrongNotes: number;
  /**
   * Server timestamp when stat was recorded
   * @format date-time
   */
  createdAt?: string;
}

/** Request to create practice statistics. Title and author are fetched from sample on backend. */
export interface CreateStatRequest {
  /** MongoDB ObjectId of the sample */
  sampleId: string;
  /** Time spent practicing in milliseconds */
  durationMs: number;
  /** Total notes pressed */
  totalNotes: number;
  /** Notes that matched expected */
  correctNotes: number;
  /** Notes that didn't match expected */
  wrongNotes: number;
}

export interface CreateStatResponse {
  /** Whether the stat was saved successfully */
  success?: boolean;
  /** ID of created stat record */
  statId?: string;
  /** Error message if failed */
  error?: string;
}

export interface StatsSummary {
  /** Total practice time in milliseconds */
  totalPracticeTimeMs?: number;
  /** Total number of practice sessions */
  totalSessions?: number;
  /** Total notes played across all sessions */
  totalNotes?: number;
  /** Total correct notes across all sessions */
  totalCorrectNotes?: number;
  /** Total wrong notes across all sessions */
  totalWrongNotes?: number;
  /** Overall accuracy (correctNotes / totalNotes, 0-1) */
  accuracy?: number;
}

export interface StatsHistoryResponse {
  stats?: StatRecord[];
  pagination?: {
    page?: number;
    limit?: number;
    total?: number;
    hasMore?: boolean;
  };
}

export interface DaySummary {
  /** ISO date (YYYY-MM-DD) */
  date?: string;
  /** Total practice duration for the day */
  totalDurationMs?: number;
  /** Number of practice sessions */
  sessionsCount?: number;
  /** Total notes played */
  totalNotes?: number;
  /** Average accuracy for the day */
  accuracy?: number;
}

export interface DailySummaryResponse {
  days?: DaySummary[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:3000";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: FormData) =>
      (Array.from(input.keys()) || []).reduce((formData, key) => {
        const property = input.get(key);
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      return data;
    });
  };
}

/**
 * @title Darpiano backend - OpenAPI 3.0
 * @version 1.0.11
 * @baseUrl http://localhost:3000
 * @externalDocs http://darpiano.ru
 *
 * Darpiano backend
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  wstoken = {
    /**
 * @description Generates a signed token for WebSocket authentication. The token expires in 1 hour and is signed using RSA SHA256.
 *
 * @tags Authentication
 * @name WstokenList
 * @summary Generate WebSocket authentication token
 * @request GET:/wstoken
 * @secure
 * @response `200` `{
  \** Token data object containing expiration and role information *\
    data: {
  \**
   * Expiration timestamp as string
   * @example "1640995200"
   *\
    exp: string,
  \**
   * User role for WebSocket authentication
   * @example "guest"
   *\
    role: string,

},
  \**
   * Base64 encoded RSA SHA256 signature of the data object
   * @example "MEUCIQDxyz123..."
   *\
    signature: string,

}` Successfully generated WebSocket token
 * @response `401` `string` Unauthorized - user not authenticated
 */
    wstokenList: (params: RequestParams = {}) =>
      this.request<
        {
          /** Token data object containing expiration and role information */
          data: {
            /**
             * Expiration timestamp as string
             * @example "1640995200"
             */
            exp: string;
            /**
             * User role for WebSocket authentication
             * @example "guest"
             */
            role: string;
          };
          /**
           * Base64 encoded RSA SHA256 signature of the data object
           * @example "MEUCIQDxyz123..."
           */
          signature: string;
        },
        string
      >({
        path: `/wstoken`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Generates a signed token for WebSocket authentication with admin role. The token expires in 1 hour and is signed using RSA SHA256. Similar to /wstoken but includes admin role information.
 *
 * @tags Authentication
 * @name AdminList
 * @summary Generate WebSocket authentication token for admin
 * @request GET:/wstoken/admin
 * @secure
 * @response `200` `{
  \** Token data object containing expiration and role information *\
    data: {
  \**
   * Expiration timestamp as string
   * @example "1640995200"
   *\
    exp: string,
  \**
   * Role identifier for admin access
   * @example "admin"
   *\
    role: string,

},
  \**
   * Base64 encoded RSA SHA256 signature of the data object
   * @example "MEUCIQDxyz123..."
   *\
    signature: string,

}` Successfully generated WebSocket token with admin role
 * @response `401` `string` Unauthorized - user not authenticated
 */
    adminList: (params: RequestParams = {}) =>
      this.request<
        {
          /** Token data object containing expiration and role information */
          data: {
            /**
             * Expiration timestamp as string
             * @example "1640995200"
             */
            exp: string;
            /**
             * Role identifier for admin access
             * @example "admin"
             */
            role: string;
          };
          /**
           * Base64 encoded RSA SHA256 signature of the data object
           * @example "MEUCIQDxyz123..."
           */
          signature: string;
        },
        string
      >({
        path: `/wstoken/admin`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  admin = {
    /**
 * @description Scrapes metadata from all URLs in a sitemap and exports as CSV. Supports test mode for limited processing.
 *
 * @tags Admin
 * @name ExportMetadataCsvList
 * @summary Export metadata CSV from sitemap
 * @request GET:/admin/export-metadata-csv/
 * @response `200` `File` CSV file generated successfully
 * @response `400` `{
  \** @example "Invalid sitemap URL" *\
    error?: string,
  \** @example "The sitemap URL returned 400: Bad Request" *\
    details?: string,

}` Invalid sitemap URL or sitemap returned 4xx error
 * @response `404` `{
  \** @example "No URLs found in sitemap" *\
    error?: string,
  \** @example "The entered sitemap URL could not be found (404)" *\
    details?: string,

}` No URLs found in sitemap or sitemap not found
 * @response `500` `{
  \** @example "Failed to export metadata" *\
    error?: string,
  \** @example "Connection timeout while processing URLs" *\
    details?: string,

}` Internal server error during metadata export
 */
    exportMetadataCsvList: (
      query?: {
        /**
         * Sitemap URL to process (defaults to https://darpiano.com/sitemap.xml if not provided)
         * @example "https://darpiano.com/sitemap.xml"
         */
        sitemapUrl?: string;
        /**
         * Enable test mode to process only 30 URLs instead of all URLs
         * @example "true"
         */
        testing?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        File,
        | {
            /** @example "Invalid sitemap URL" */
            error?: string;
            /** @example "The sitemap URL returned 400: Bad Request" */
            details?: string;
          }
        | {
            /** @example "No URLs found in sitemap" */
            error?: string;
            /** @example "The entered sitemap URL could not be found (404)" */
            details?: string;
          }
        | {
            /** @example "Failed to export metadata" */
            error?: string;
            /** @example "Connection timeout while processing URLs" */
            details?: string;
          }
      >({
        path: `/admin/export-metadata-csv/`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
 * @description Uploads and stores a CSV file in MongoDB with automatic change detection and Manual Overwrite column management. Maintains a maximum of 10 stored CSVs.
 *
 * @tags Admin
 * @name StoreMetadataCsvCreate
 * @summary Store uploaded CSV with Manual Overwrite tracking
 * @request POST:/admin/store-metadata-csv/
 * @response `201` `{
  \** @example true *\
    success: boolean,
  \** @example "CSV stored successfully with Manual Overwrite tracking" *\
    message: string,
  \**
   * Number of data rows processed
   * @example 150
   *\
    rowCount: number,
  \**
   * Size of uploaded file in bytes
   * @example 8192
   *\
    originalFileSize: number,
  \**
   * Number of field changes detected compared to previous CSV
   * @example 5
   *\
    changesDetected: number,
  \**
   * Whether a previous CSV existed for comparison
   * @example true
   *\
    hadPreviousCsv: boolean,
  \**
   * Timestamp when the CSV was stored
   * @format date-time
   * @example "2023-12-01T10:30:00.000Z"
   *\
    createdAt: string,
  \**
   * MongoDB document ID of the stored CSV
   * @example "656a1b2c3d4e5f6789012345"
   *\
    documentId: string,

}` CSV stored successfully with change detection results
 * @response `400` `{
  \** @example "CSV file is empty or contains only headers" *\
    error?: string,

}` Bad request - invalid or missing CSV file
 * @response `500` `{
  \** @example "Failed to store CSV" *\
    error?: string,
  \** @example "Database connection failed" *\
    details?: string,

}` Internal server error during CSV storage
 */
    storeMetadataCsvCreate: (
      data: {
        /**
         * CSV file to upload and store
         * @format binary
         */
        csvFile: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example true */
          success: boolean;
          /** @example "CSV stored successfully with Manual Overwrite tracking" */
          message: string;
          /**
           * Number of data rows processed
           * @example 150
           */
          rowCount: number;
          /**
           * Size of uploaded file in bytes
           * @example 8192
           */
          originalFileSize: number;
          /**
           * Number of field changes detected compared to previous CSV
           * @example 5
           */
          changesDetected: number;
          /**
           * Whether a previous CSV existed for comparison
           * @example true
           */
          hadPreviousCsv: boolean;
          /**
           * Timestamp when the CSV was stored
           * @format date-time
           * @example "2023-12-01T10:30:00.000Z"
           */
          createdAt: string;
          /**
           * MongoDB document ID of the stored CSV
           * @example "656a1b2c3d4e5f6789012345"
           */
          documentId: string;
        },
        | {
            /** @example "CSV file is empty or contains only headers" */
            error?: string;
          }
        | {
            /** @example "Failed to store CSV" */
            error?: string;
            /** @example "Database connection failed" */
            details?: string;
          }
      >({
        path: `/admin/store-metadata-csv/`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Downloads the most recently stored CSV with an added 'title length' column. Excludes test documents by default.
 *
 * @tags Admin
 * @name DownloadLatestCsvList
 * @summary Download the latest stored CSV with enhancements
 * @request GET:/admin/download-latest-csv/
 * @response `200` `File` CSV file downloaded successfully with title length column added
 * @response `404` `{
  \** @example "No CSV found" *\
    error?: string,
  \** @example "No CSV files stored in the database" *\
    message?: string,

}` No CSV files found in database
 * @response `500` `{
  \** @example "Failed to download CSV" *\
    error?: string,
  \** @example "Error parsing stored CSV data" *\
    details?: string,

}` Internal server error during CSV processing or download
 */
    downloadLatestCsvList: (
      query?: {
        /**
         * Include test documents in the search for latest CSV (used primarily for testing)
         * @example "false"
         */
        includeTestDocs?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        File,
        | {
            /** @example "No CSV found" */
            error?: string;
            /** @example "No CSV files stored in the database" */
            message?: string;
          }
        | {
            /** @example "Failed to download CSV" */
            error?: string;
            /** @example "Error parsing stored CSV data" */
            details?: string;
          }
      >({
        path: `/admin/download-latest-csv/`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  api = {
    /**
 * @description Retrieve current game stats (last saved progress and highest score). If no progress exists for the user and sample, returns default/zero values instead of an error. This ensures consistent API behavior for new users starting their first practice session.
 *
 * @tags GameStats
 * @name GameStatsDetail
 * @summary Get game progress for a user and sample
 * @request GET:/api/gameStats/{userId}/{sampleId}
 * @secure
 * @response `200` `{
    progress?: {
  \** User identifier *\
    userId?: string,
  \** Sample identifier *\
    sampleId?: string,
    stats?: {
  \** Highest score achieved (0 if no previous progress) *\
    highestScore?: number,
    lastSaved?: {
  \** Current score (0 if no previous progress) *\
    currentScore?: number,
  \** Last saved measure index (0 if no previous progress) *\
    measureIndex?: number,
  \** Current multiplier (1.0 if no previous progress) *\
    multiplier?: number,

},

},

},

}` Progress found or default values returned if no progress exists
 * @response `400` `any` Invalid or missing IDs
 * @response `404` `any` Sample not found
 * @response `500` `any` Server error
 */
    gameStatsDetail: (userId: string, sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          progress?: {
            /** User identifier */
            userId?: string;
            /** Sample identifier */
            sampleId?: string;
            stats?: {
              /** Highest score achieved (0 if no previous progress) */
              highestScore?: number;
              lastSaved?: {
                /** Current score (0 if no previous progress) */
                currentScore?: number;
                /** Last saved measure index (0 if no previous progress) */
                measureIndex?: number;
                /** Current multiplier (1.0 if no previous progress) */
                multiplier?: number;
              };
            };
          };
        },
        any
      >({
        path: `/api/gameStats/${userId}/${sampleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Update last saved measure, score, multiplier. Updates `highestScore` if current score is higher. **Rate-limited: 1 request every 5 seconds per user**.
 *
 * @tags GameStats
 * @name GameStatsCreate
 * @summary Update game progress
 * @request POST:/api/gameStats/{userId}/{sampleId}
 * @secure
 * @response `200` `{
    gameStats?: GameStats,

}` Progress updated
 * @response `400` `void` Invalid input
 * @response `404` `void` Sample not found
 * @response `429` `{
  \** @example "Too many progress updates. Please wait before sending another update." *\
    error?: string,

}` Rate limit exceeded
 * @response `500` `void` Server error
 */
    gameStatsCreate: (
      userId: string,
      sampleId: string,
      data: {
        /** @min 0 */
        measureIndex?: number;
        /** @min 0 */
        currentScore: number;
        /**
         * @min 1
         * @default 1
         */
        multiplier?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          gameStats?: GameStats;
        },
        void | {
          /** @example "Too many progress updates. Please wait before sending another update." */
          error?: string;
        }
      >({
        path: `/api/gameStats/${userId}/${sampleId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Resets the saved progress for a user and sample to starting values while preserving the high score. This is ideal for "Replay" functionality where users want to restart but keep their achievements. **What gets reset:** - Current score → 0 - Measure index → 0 - Multiplier → 1.0 - Updated timestamp → current time **What is preserved:** - High score (highest score achieved)
 *
 * @tags GameStats
 * @name GameStatsDelete
 * @summary Reset game progress (preserves high score)
 * @request DELETE:/api/gameStats/{userId}/{sampleId}
 * @secure
 * @response `200` `{
  \** @example "Progress deleted successfully for the user 65550a603786ac4911089e91 and sample 507f1f77bcf86cd799439012" *\
    message?: string,

}` Progress reset successfully (high score preserved)
 * @response `400` `void` Invalid IDs
 * @response `404` `void` Sample not found
 * @response `500` `void` Server error
 */
    gameStatsDelete: (userId: string, sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "Progress deleted successfully for the user 65550a603786ac4911089e91 and sample 507f1f77bcf86cd799439012" */
          message?: string;
        },
        void
      >({
        path: `/api/gameStats/${userId}/${sampleId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Save practice statistics for a sample session. Called when: - User switches to a different sample (if 5+ notes played) - 15 seconds of inactivity (if 5+ notes played) - User closes browser/tab (if 5+ notes played)
 *
 * @tags Stats
 * @name StatsCreate
 * @summary Save practice statistics
 * @request POST:/api/stats
 * @secure
 * @response `201` `CreateStatResponse` Statistics saved successfully
 * @response `400` `{
  \** @example false *\
    success?: boolean,
  \** @example "Missing required field: sampleId" *\
    error?: string,

}` Validation error or sample not found
 * @response `401` `void` Unauthorized - missing or invalid token
 * @response `500` `void` Server error
 */
    statsCreate: (data: CreateStatRequest, params: RequestParams = {}) =>
      this.request<
        CreateStatResponse,
        {
          /** @example false */
          success?: boolean;
          /** @example "Missing required field: sampleId" */
          error?: string;
        } | void
      >({
        path: `/api/stats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get aggregated statistics for the authenticated user. Used for profile page header display showing total practice time, sessions count, notes played, and overall accuracy.
     *
     * @tags Stats
     * @name StatsSummaryList
     * @summary Get aggregated stats summary
     * @request GET:/api/stats/summary
     * @secure
     * @response `200` `StatsSummary` Aggregated stats summary
     * @response `401` `void` Unauthorized - missing or invalid token
     * @response `500` `void` Server error
     */
    statsSummaryList: (params: RequestParams = {}) =>
      this.request<StatsSummary, void>({
        path: `/api/stats/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user's practice history with pagination and filtering. Returns individual practice session records sorted by date (newest first).
     *
     * @tags Stats
     * @name StatsHistoryList
     * @summary Get practice history
     * @request GET:/api/stats/history
     * @secure
     * @response `200` `StatsHistoryResponse` Practice history with pagination
     * @response `401` `void` Unauthorized - missing or invalid token
     * @response `500` `void` Server error
     */
    statsHistoryList: (
      query?: {
        /**
         * Start of date range (ISO string). Default is 30 days ago.
         * @format date-time
         * @example "2024-01-01T00:00:00.000Z"
         */
        startDate?: string;
        /**
         * End of date range (ISO string). Default is today.
         * @format date-time
         * @example "2024-01-31T23:59:59.999Z"
         */
        endDate?: string;
        /**
         * Filter by specific sample ID
         * @example "507f1f77bcf86cd799439011"
         */
        sampleId?: string;
        /**
         * Page number for pagination
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Number of items per page (max 100)
         * @min 1
         * @max 100
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<StatsHistoryResponse, void>({
        path: `/api/stats/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get daily aggregated statistics for chart display. Returns one entry per day with totals for that day.
     *
     * @tags Stats
     * @name StatsDailySummaryList
     * @summary Get daily aggregated stats
     * @request GET:/api/stats/daily-summary
     * @secure
     * @response `200` `DailySummaryResponse` Daily aggregated stats
     * @response `401` `void` Unauthorized - missing or invalid token
     * @response `500` `void` Server error
     */
    statsDailySummaryList: (
      query?: {
        /**
         * Number of days to fetch (max 365)
         * @min 1
         * @max 365
         * @default 30
         */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DailySummaryResponse, void>({
        path: `/api/stats/daily-summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  logout = {
    /**
     * @description Logs out the user by invalidating their refresh token in Keycloak. Requires a valid access token for authorization.
     *
     * @tags Authentication
     * @name LogoutCreate
     * @summary Logout user from Keycloak
     * @request POST:/logout
     * @response `204` `void` Successfully logged out
     * @response `400` `string` Missing iss parameter from access_token
     * @response `401` `string` Unauthorized - invalid access token
     */
    logoutCreate: (
      data: {
        /** The user's access token */
        accessToken: string;
        /** The user's refresh token to be invalidated */
        refreshToken: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, string>({
        path: `/logout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  userinfo = {
    /**
 * No description
 *
 * @name UserinfoList
 * @summary Get user roles and sub
 * @request GET:/userinfo
 * @response `200` `{
    roles?: (string)[],
    sub?: string,

}` Success
 * @response `400` `{
  \** Error msg *\
    msg?: string,

}` No auth data
 */
    userinfoList: (params: RequestParams = {}) =>
      this.request<
        {
          roles?: string[];
          sub?: string;
        },
        {
          /** Error msg */
          msg?: string;
        }
      >({
        path: `/userinfo`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
 * @description Fetches complete user details including avatar URL from Keycloak using admin token
 *
 * @tags User Management
 * @name DetailsList
 * @summary Get user details with avatar info from Keycloak
 * @request GET:/user/details
 * @secure
 * @response `200` `{
  \** User ID *\
    sub?: string,
  \** User email *\
    email?: string,
  \** User first name *\
    firstName?: string,
  \** User last name *\
    lastName?: string,
  \** Username *\
    preferred_username?: string,
  \** Display name *\
    displayName?: string,
  \** Avatar URL path *\
    avatarURL?: string | null,

}` Successfully retrieved user details
 * @response `400` `void` User ID not found in token
 * @response `401` `void` Unauthorized
 * @response `500` `void` Failed to fetch user details
 */
    detailsList: (params: RequestParams = {}) =>
      this.request<
        {
          /** User ID */
          sub?: string;
          /** User email */
          email?: string;
          /** User first name */
          firstName?: string;
          /** User last name */
          lastName?: string;
          /** Username */
          preferred_username?: string;
          /** Display name */
          displayName?: string;
          /** Avatar URL path */
          avatarURL?: string | null;
        },
        void
      >({
        path: `/user/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows updating the user's first name, last name, and username by taking the information from the Keycloak token.
     *
     * @tags User Management
     * @name UpdateUser
     * @summary Update user details in Keycloak
     * @request PUT:/user
     * @secure
     * @response `200` `void` Successfully updated the user
     * @response `400` `void` Missing required fields or invalid data
     * @response `500` `void` Internal server error when updating user
     */
    updateUser: (
      data: {
        /** First name of the User. */
        firstName?: string;
        /** Last name of the User. */
        lastName?: string;
        /** Name that should be displayed in public. */
        displayName?: string;
        /** URL of avatar. */
        avatarURL?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/user`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
  };
  debugEvents = {
    /**
 * @description Retrieve a list of all UUIDs along with their associated usernames and dates.
 *
 * @tags debugEvents
 * @name UuiDsList
 * @summary Retrieve all UUIDs
 * @request GET:/debugEvents/UUIDs
 * @response `200` `{
    uuids: ({
  \** The UUID *\
    uuid: string,
  \** The associated username *\
    username: string,
  \**
   * The date associated with the UUID
   * @format date
   *\
    date: string,

})[],

}` Successful operation
 * @response `500` `{
  \** Error message *\
    error: string,

}` Internal Server Error
 */
    uuiDsList: (params: RequestParams = {}) =>
      this.request<
        {
          uuids: {
            /** The UUID */
            uuid: string;
            /** The associated username */
            username: string;
            /**
             * The date associated with the UUID
             * @format date
             */
            date: string;
          }[];
        },
        {
          /** Error message */
          error: string;
        }
      >({
        path: `/debugEvents/UUIDs`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all debug event entries from the MongoDB collection.
     *
     * @tags debugEvents
     * @name DebugEventsList
     * @summary Retrieve all debug events
     * @request GET:/debugEvents
     * @response `200` `(DebugData)[]` Successful operation
     * @response `500` `string` Internal Server Error
     */
    debugEventsList: (params: RequestParams = {}) =>
      this.request<DebugData[], string>({
        path: `/debugEvents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new debug event entry.
     *
     * @tags debugEvents
     * @name DebugEventsCreate
     * @summary Create a new debug event
     * @request POST:/debugEvents
     * @response `201` `DebugData` Debug event created successfully
     * @response `500` `string` Internal Server Error
     */
    debugEventsCreate: (data: DebugData, params: RequestParams = {}) =>
      this.request<DebugData, string>({
        path: `/debugEvents`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieve debug data by UUID, including UUID, username, date, sample ID, practice mode ID, and events.
 *
 * @tags debugEvents
 * @name DebugEventsDetail
 * @summary Retrieve debug data by UUID
 * @request GET:/debugEvents/{uuid}
 * @response `200` `DebugData` Successful operation
 * @response `404` `{
  \** Error message *\
    error: string,

}` Debug data not found
 * @response `500` `{
  \** Error message *\
    error: string,

}` Internal Server Error
 */
    debugEventsDetail: (uuid: string, params: RequestParams = {}) =>
      this.request<
        DebugData,
        {
          /** Error message */
          error: string;
        }
      >({
        path: `/debugEvents/${uuid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Deletes a debug event and associated video file by UUID.
 *
 * @tags debugEvents
 * @name DebugEventsDelete
 * @summary Delete debug event by UUID
 * @request DELETE:/debugEvents/{uuid}
 * @response `200` `{
    message: string,
    deletedData: DebugData,

}` Data deleted successfully
 * @response `404` `{
    message: string,

}` Data not found
 * @response `500` `{
    message: string,

}` Internal Server Error
 */
    debugEventsDelete: (uuid: string, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
          deletedData: DebugData;
        },
        {
          message: string;
        }
      >({
        path: `/debugEvents/${uuid}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
 * @description Updates an existing debug data entry by its unique ID. Allows partial updates of fields such as events, sample, practice mode ID, autosaved status, and auto-removable status.
 *
 * @tags debugEvents
 * @name DebugEventsUpdate
 * @summary Update debug data by ID
 * @request PUT:/debugEvents/{uuid}
 * @response `200` `DebugData` Debug data successfully updated
 * @response `404` `{
  \** Error message *\
    error: string,

}` Debug data not found
 * @response `500` `{
  \** Error message *\
    error: string,

}` Internal Server Error
 */
    debugEventsUpdate: (
      uuid: string,
      data: {
        /** List of updated events */
        events?: object[];
        /** Updated sample data */
        sample?: string;
        /** Updated practice mode ID */
        practiceModeId?: string;
        /** Whether the data is autosaved */
        autosaved?: boolean;
        /** Whether the data is auto-removable */
        autoRemovable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        DebugData,
        {
          /** Error message */
          error: string;
        }
      >({
        path: `/debugEvents/${uuid}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new debug event entry.
     *
     * @tags debugEvents
     * @name AutosaveCreate
     * @summary Create a new debug event
     * @request POST:/debugEvents/autosave
     * @response `201` `DebugData` Debug event created successfully
     * @response `500` `string` Internal Server Error
     */
    autosaveCreate: (data: DebugData, params: RequestParams = {}) =>
      this.request<DebugData, string>({
        path: `/debugEvents/autosave`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  debugVideo = {
    /**
 * @description Uploads a debug video file to S3.
 *
 * @tags debugVideo
 * @name DebugVideoCreate
 * @summary Upload debug video
 * @request POST:/debugVideo
 * @response `200` `{
    message: string,

}` Video saved to S3 successfully
 * @response `500` `{
    error: string,

}` Internal Server Error
 */
    debugVideoCreate: (
      data: {
        /** @format binary */
        file: File;
        /** UUID associated with the video file */
        uuid: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          message: string;
        },
        {
          error: string;
        }
      >({
        path: `/debugVideo`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves a debug video file from AWS S3 by UUID.
 *
 * @tags debugVideo
 * @name DebugVideoDetail
 * @summary Retrieve debug video by UUID
 * @request GET:/debugVideo/{uuid}
 * @response `200` `File` Video retrieved successfully
 * @response `404` `{
    error: string,

}` Video not found
 * @response `500` `{
    error: string,

}` Internal Server Error
 */
    debugVideoDetail: (uuid: string, params: RequestParams = {}) =>
      this.request<
        File,
        {
          error: string;
        }
      >({
        path: `/debugVideo/${uuid}`,
        method: "GET",
        ...params,
      }),

    /**
 * @description Deletes a debug video file from AWS S3 by UUID.
 *
 * @tags debugVideo
 * @name DebugVideoDelete
 * @summary Delete debug video by UUID
 * @request DELETE:/debugVideo/{uuid}
 * @response `200` `{
    message: string,

}` File deleted successfully
 * @response `500` `{
    error: string,

}` Internal Server Error
 */
    debugVideoDelete: (uuid: string, params: RequestParams = {}) =>
      this.request<
        {
          message: string;
        },
        {
          error: string;
        }
      >({
        path: `/debugVideo/${uuid}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  samples = {
    /**
 * @description Uploads an audio file to S3, remove old file if it's was specified, and updates the audio path in the database.
 *
 * @tags Samples
 * @name AudioCreate
 * @summary Upload audio file
 * @request POST:/samples/audio
 * @response `200` `{
    msg: string,
    audioPath?: string,

}` File uploaded to S3
 * @response `400` `string` Bad Request
 * @response `500` `{
    error: string,

}` Internal Server Error
 */
    audioCreate: (
      data: {
        /** @format binary */
        audio: File;
        audioFilename: string;
        /** The ID of the sample associated with the audio file */
        sampleId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          msg: string;
          audioPath?: string;
        },
        | string
        | {
            error: string;
          }
      >({
        path: `/samples/audio`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Uploads a MIDI file to AWS S3 and updates the MIDI path in the database.
 *
 * @tags Samples
 * @name MidiCreate
 * @summary Upload MIDI file
 * @request POST:/samples/midi
 * @response `200` `{
    msg: string,
    midiPath?: string,

}` Saved successfully
 * @response `400` `string` Bad Request
 * @response `500` `{
    error: string,

}` Internal Server Error
 */
    midiCreate: (
      data: {
        /** @format binary */
        midi: File;
        /** The name of the MIDI file. */
        fileName: string;
        /** The ID of the sample associated with the MIDI file. */
        sampleId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          msg: string;
          midiPath?: string;
        },
        | string
        | {
            error: string;
          }
      >({
        path: `/samples/midi`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Encrypts MusicXML content using the default password. Rate limited to 50 requests per 15 minutes per IP/user.
 *
 * @tags Samples
 * @name EncryptMusicxmlCreate
 * @summary Encrypt MusicXML content
 * @request POST:/samples/encryptMusicxml
 * @response `200` `{
  \**
   * Indicates successful encryption
   * @example true
   *\
    success: boolean,
  \**
   * Base64 encoded encrypted MusicXML data
   * @example "MEUCIQDxyz123..."
   *\
    encryptedMusicxml: string,
  \**
   * Encryption algorithm used
   * @example "AES-CBC"
   *\
    algorithm: string,

}` MusicXML encrypted successfully
 * @response `400` `{
  \** @example "No MusicXML content provided or invalid format" *\
    error: string,

}` Bad Request - Invalid or missing MusicXML content
 * @response `429` `{
  \** @example "Too many encryption requests, please try again later." *\
    error: string,

}` Too Many Requests - Rate limit exceeded
 * @response `500` `{
  \** @example "Failed to encrypt MusicXML data" *\
    error: string,
  \** Additional error details *\
    details?: string,

}` Internal Server Error - Encryption failed
 */
    encryptMusicxmlCreate: (
      data: {
        /**
         * The MusicXML content to encrypt as a string
         * @example "<?xml version="1.0" encoding="UTF-8"?><score-partwise version="3.1">...</score-partwise>"
         */
        musicxml: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * Indicates successful encryption
           * @example true
           */
          success: boolean;
          /**
           * Base64 encoded encrypted MusicXML data
           * @example "MEUCIQDxyz123..."
           */
          encryptedMusicxml: string;
          /**
           * Encryption algorithm used
           * @example "AES-CBC"
           */
          algorithm: string;
        },
        | {
            /** @example "No MusicXML content provided or invalid format" */
            error: string;
          }
        | {
            /** @example "Too many encryption requests, please try again later." */
            error: string;
          }
        | {
            /** @example "Failed to encrypt MusicXML data" */
            error: string;
            /** Additional error details */
            details?: string;
          }
      >({
        path: `/samples/encryptMusicxml`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves all samples (only objects).
 *
 * @tags Samples
 * @name SamplesList
 * @summary Get all samples (Only objects, without files)
 * @request GET:/samples/
 * @response `200` `{
    allSamples: (Sample)[],

}` Samples retrieved successfully
 * @response `404` `{
    error: string,

}` No samples found
 * @response `500` `{
    error: string,

}` Internal Server Error
 */
    samplesList: (params: RequestParams = {}) =>
      this.request<
        {
          allSamples: Sample[];
        },
        {
          error: string;
        }
      >({
        path: `/samples/`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Uploads a sample, including musicxml and cache data.
 *
 * @tags Samples
 * @name SamplesCreate
 * @summary Upload a sample
 * @request POST:/samples/
 * @response `200` `{
  \** @example "saved successfully" *\
    msg: string,
    data: Sample,

}` Sample saved successfully
 * @response `400` `{
  \** @example "Error details" *\
    error: string,

}` Error saving sample
 */
    samplesCreate: (
      data: {
        /** Should this sample be public */
        public: boolean;
        /**
         * The musicxml content as a string.
         * @example "<musicxml></musicxml>"
         */
        musicxml: string;
        /**
         * The cache content as a JSON object.
         * @example {"key":"value"}
         */
        cache: object;
        /**
         * Musicxml filename.
         * @example "filename.musicxml"
         */
        musicxmlFilename: string;
        /**
         * Category of the sample.
         * @example "category1"
         */
        category: Category;
        metadata: {
          /**
           * Title of the sample.
           * @example "Sample Title"
           */
          title?: string;
          /**
           * Author of the sample.
           * @example "Author Name"
           */
          author?: Author;
          /**
           * Indicates whether MIDI data is loaded.
           * @example true
           */
          midiLoaded?: boolean;
          /**
           * Number of wrong notes in the MIDI data.
           * @example 5
           */
          midiWrongNotesCount?: number;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "saved successfully" */
          msg: string;
          data: Sample;
        },
        {
          /** @example "Error details" */
          error: string;
        }
      >({
        path: `/samples/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Updates an existing sample with the provided data.
 *
 * @tags Samples
 * @name SamplesUpdate
 * @summary Update a sample
 * @request PUT:/samples/
 * @response `200` `{
  \** @example "Update successful" *\
    msg: string,
    updatedSample: Sample,

}` Sample updated successfully
 * @response `400` `{
  \** @example "Error updating sample" *\
    msg: string,

}` Error updating sample
 * @response `404` `{
  \** @example "Sample not found" *\
    msg: string,

}` Sample not found
 */
    samplesUpdate: (
      data: {
        sample: Sample;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "Update successful" */
          msg: string;
          updatedSample: Sample;
        },
        | {
            /** @example "Error updating sample" */
            msg: string;
          }
        | {
            /** @example "Sample not found" */
            msg: string;
          }
      >({
        path: `/samples/`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Updates the MusicXML and cache data for an existing sample, deleting the old data if it exists.
 *
 * @tags Samples
 * @name MusicxmlUpdate
 * @summary Update MusicXML for a sample
 * @request PUT:/samples/musicxml
 * @response `200` `{
  \** @example "Update successful" *\
    msg: string,
    updatedSample: Sample,

}` Update successful
 * @response `400` `{
  \** @example "Cannot find sample with that id" *\
    msg: string,

}` Error or sample not found
 */
    musicxmlUpdate: (
      data: {
        /** The ID of the sample to update. */
        sampleId: string;
        /** The new MusicXML data. */
        musicxml: string;
        /** Filename of musicxml */
        musicxmlFilename: string;
        /** The new cache data. */
        cache: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "Update successful" */
          msg: string;
          updatedSample: Sample;
        },
        {
          /** @example "Cannot find sample with that id" */
          msg: string;
        }
      >({
        path: `/samples/musicxml`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Deletes a sample and associated files.
 *
 * @tags Samples
 * @name SamplesDelete
 * @summary Delete sample
 * @request DELETE:/samples/{sampleId}
 * @response `200` `{
  \** @example "delete success" *\
    msg: string,

}` Sample deleted successfully
 * @response `404` `{
  \** @example "Sample not found" *\
    msg: string,

}` Sample not found
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    samplesDelete: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "delete success" */
          msg: string;
        },
        | {
            /** @example "Sample not found" */
            msg: string;
          }
        | {
            /** Error message. */
            error: string;
          }
      >({
        path: `/samples/${sampleId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves the MusicXML, cache, and hash data for a specified sample.
 *
 * @tags Samples
 * @name SamplesDetail
 * @summary Get sample data
 * @request GET:/samples/{sampleId}
 * @response `200` `{
  \** CDN URL for the encrypted MusicXML file. *\
    musicxmlUrl: string,
  \** CDN URL for the encrypted cache file. *\
    cacheUrl?: string | null,
  \** CDN URL for the WebP preview image. *\
    webpUrl?: string | null,
    sample: Sample,
  \** Indicates that files are encrypted in storage. *\
    encrypted: boolean,

}` Sample data retrieved successfully
 * @response `404` `{
  \** @example "Sample not found" *\
    msg: string,

}` Sample not found
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    samplesDetail: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** CDN URL for the encrypted MusicXML file. */
          musicxmlUrl: string;
          /** CDN URL for the encrypted cache file. */
          cacheUrl?: string | null;
          /** CDN URL for the WebP preview image. */
          webpUrl?: string | null;
          sample: Sample;
          /** Indicates that files are encrypted in storage. */
          encrypted: boolean;
        },
        | {
            /** @example "Sample not found" */
            msg: string;
          }
        | {
            /** Error message. */
            error: string;
          }
      >({
        path: `/samples/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Updates the cache data for a sample.
 *
 * @tags Samples
 * @name CacheUpdate
 * @summary Update sample cache
 * @request PUT:/samples/cache
 * @response `200` `{
  \** @example "Success" *\
    message: string,

}` Cache updated successfully
 * @response `404` `{
  \** @example "Sample not found for given id" *\
    msg: string,
  \** @example "Recieved cache length is not equal to sended cache length" *\
    "msg2"?: string,

}` Sample not found or cache length mismatch
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    cacheUpdate: (
      data: {
        /** The ID of the sample to update cache for. */
        sampleId: string;
        /** The cache data to be uploaded. */
        cache: string;
        /** The length of the cache data sent. */
        cacheLength: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "Success" */
          message: string;
        },
        | {
            /** @example "Sample not found for given id" */
            msg: string;
            /** @example "Recieved cache length is not equal to sended cache length" */
            msg2?: string;
          }
        | {
            /** Error message. */
            error: string;
          }
      >({
        path: `/samples/cache`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Returns a CDN URL to the encrypted audio file for the sample.
 *
 * @tags Samples
 * @name AudioDetail
 * @summary Get audio file CDN URL
 * @request GET:/samples/audio/{sampleId}
 * @response `200` `{
  \**
   * CDN URL for the encrypted audio file.
   * @example "https://cdn.darpiano.com/audio/audio-123.mp3"
   *\
    audioUrl: string,
  \**
   * Indicates that the audio file is encrypted.
   * @example true
   *\
    encrypted: boolean,

}` Audio URL retrieved successfully
 * @response `404` `{
  \** @example "Sample not found, or sample don't have any audio path" *\
    msg: string,

}` Sample not found or no audio file associated
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    audioDetail: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * CDN URL for the encrypted audio file.
           * @example "https://cdn.darpiano.com/audio/audio-123.mp3"
           */
          audioUrl: string;
          /**
           * Indicates that the audio file is encrypted.
           * @example true
           */
          encrypted: boolean;
        },
        | {
            /** @example "Sample not found, or sample don't have any audio path" */
            msg: string;
          }
        | {
            /** Error message. */
            error: string;
          }
      >({
        path: `/samples/audio/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Returns a CDN URL to the encrypted MIDI file for the sample.
 *
 * @tags Samples
 * @name MidiDetail
 * @summary Get MIDI file CDN URL
 * @request GET:/samples/midi/{sampleId}
 * @response `200` `{
  \**
   * CDN URL for the encrypted MIDI file.
   * @example "https://cdn.darpiano.com/midi/midi-456.mid"
   *\
    midiUrl: string,
  \**
   * Indicates that the MIDI file is encrypted.
   * @example true
   *\
    encrypted: boolean,

}` MIDI URL retrieved successfully
 * @response `404` `{
  \** @example "Sample not found" *\
    msg: string,

}` Sample not found or no MIDI file associated
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    midiDetail: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * CDN URL for the encrypted MIDI file.
           * @example "https://cdn.darpiano.com/midi/midi-456.mid"
           */
          midiUrl: string;
          /**
           * Indicates that the MIDI file is encrypted.
           * @example true
           */
          encrypted: boolean;
        },
        | {
            /** @example "Sample not found" */
            msg: string;
          }
        | {
            /** Error message. */
            error: string;
          }
      >({
        path: `/samples/midi/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Deletes the MIDI file associated with a sample.
 *
 * @tags Samples
 * @name MidiDelete
 * @summary Delete MIDI file
 * @request DELETE:/samples/midi/{sampleId}
 * @response `200` `{
  \** @example "delete success" *\
    msg: string,

}` MIDI file deleted successfully
 * @response `400` `{
  \** Error message. *\
    error: string,

}` Bad Request
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    midiDelete: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "delete success" */
          msg: string;
        },
        {
          /** Error message. */
          error: string;
        }
      >({
        path: `/samples/midi/${sampleId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
 * @description Exports all samples (based on user permissions) to a CSV file for bulk editing. Only accessible by administrators.
 *
 * @tags Samples
 * @name ExportcsvList
 * @summary Export samples to CSV for bulk editing
 * @request GET:/samples/exportcsv/
 * @secure
 * @response `200` `File` CSV file generated successfully
 * @response `403` `{
  \** @example "Access denied" *\
    msg: string,

}` Access denied - admin role required
 * @response `404` `{
  \** @example "No samples found" *\
    error: string,

}` No samples found
 * @response `500` `{
  \** @example "Internal Server Error" *\
    error: string,

}` Internal Server Error
 */
    exportcsvList: (params: RequestParams = {}) =>
      this.request<
        File,
        | {
            /** @example "Access denied" */
            msg: string;
          }
        | {
            /** @example "No samples found" */
            error: string;
          }
        | {
            /** @example "Internal Server Error" */
            error: string;
          }
      >({
        path: `/samples/exportcsv/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * @description Imports a CSV file and performs bulk updates on existing samples. Creates automatic MongoDB backup before import. Only accessible by administrators.
 *
 * @tags Samples
 * @name ImportcsvCreate
 * @summary Import CSV and bulk update samples
 * @request POST:/samples/importcsv/
 * @secure
 * @response `200` `{
  \** @example "Bulk update complete" *\
    msg: string,
    results: {
  \**
   * Total number of rows processed
   * @example 10
   *\
    total: number,
  \**
   * Number of samples successfully updated
   * @example 8
   *\
    updated: number,
  \**
   * Number of rows that failed to update
   * @example 2
   *\
    failed: number,
  \**
   * List of error messages for failed updates
   * @example ["Row 3: Sample with identifier abc123 not found"]
   *\
    errors: (string)[],

},

}` Bulk update completed successfully
 * @response `400` `{
  \** @example "No CSV file uploaded" *\
    msg: string,

}` Bad request - no CSV file uploaded
 * @response `403` `{
  \** @example "Only administrators can perform bulk updates" *\
    msg: string,

}` Access denied - admin role required
 * @response `500` `{
  \** @example "Error processing CSV file: [error details]" *\
    error: string,

}` Internal Server Error
 */
    importcsvCreate: (
      data: {
        /**
         * CSV content as string with headers - identifier, title_en, title_ru, author_en, author_ru, category_en, category_ru, manualChangelog
         * @example "identifier,title_en,title_ru,author_en,author_ru
         * abc123,New Title,Новый заголовок,New Author,Новый автор"
         */
        csvContent: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "Bulk update complete" */
          msg: string;
          results: {
            /**
             * Total number of rows processed
             * @example 10
             */
            total: number;
            /**
             * Number of samples successfully updated
             * @example 8
             */
            updated: number;
            /**
             * Number of rows that failed to update
             * @example 2
             */
            failed: number;
            /**
             * List of error messages for failed updates
             * @example ["Row 3: Sample with identifier abc123 not found"]
             */
            errors: string[];
          };
        },
        | {
            /** @example "No CSV file uploaded" */
            msg: string;
          }
        | {
            /** @example "Only administrators can perform bulk updates" */
            msg: string;
          }
        | {
            /** @example "Error processing CSV file: [error details]" */
            error: string;
          }
      >({
        path: `/samples/importcsv/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Adds a new favorite item (`ALBUM`, `SAMPLE`, or `FRAGMENT`) to the user's list. Prevents duplicates.
 *
 * @tags Favorites
 * @name FavoritesCreate
 * @summary Add a favorite item for the authenticated user
 * @request POST:/samples/favorites
 * @secure
 * @response `200` `{
  \** @example "Sample added to favorites successfully" *\
    msg?: string,

}` Favorite item added successfully
 * @response `400` `{
  \** @example "Invalid favorite type" *\
    msg?: string,

}` Bad request due to missing or invalid input
 * @response `500` `{
  \** @example "Failed to add Sample to favorites" *\
    error?: string,

}` Server error while adding the favorite item
 */
    favoritesCreate: (
      data: {
        /**
         * ID of the item to add to favorites
         * @example "PJpJTBtlQcML"
         */
        id: string;
        /**
         * Type of the favorite item
         * @example "SAMPLE"
         */
        type: "ALBUM" | "SAMPLE" | "FRAGMENT";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "Sample added to favorites successfully" */
          msg?: string;
        },
        | {
            /** @example "Invalid favorite type" */
            msg?: string;
          }
        | {
            /** @example "Failed to add Sample to favorites" */
            error?: string;
          }
      >({
        path: `/samples/favorites`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves all favorites for the authenticated user. Optionally filters by type if provided. Returns an empty list if the user has no favorites.
 *
 * @tags Favorites
 * @name FavoritesDetail
 * @summary Get user favorites (all or filtered by type)
 * @request GET:/samples/favorites/{type}
 * @secure
 * @response `200` `{
    favorites?: ({
  \** @example "PJpJTBtlQcML" *\
    id?: string,
  \** @example "SAMPLE" *\
    type?: string,

})[],

}` Successfully retrieved favorites
 * @response `400` `{
  \** @example "User ID is missing" *\
    msg?: string,

}` User ID is missing
 * @response `500` `{
  \** @example "Error while getting favorites" *\
    msg?: string,

}` Server error while fetching favorites
 */
    favoritesDetail: (type?: "ALBUM" | "SAMPLE" | "FRAGMENT", params: RequestParams = {}) =>
      this.request<
        {
          favorites?: {
            /** @example "PJpJTBtlQcML" */
            id?: string;
            /** @example "SAMPLE" */
            type?: string;
          }[];
        },
        | {
            /** @example "User ID is missing" */
            msg?: string;
          }
        | {
            /** @example "Error while getting favorites" */
            msg?: string;
          }
      >({
        path: `/samples/favorites/${type}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Removes a specific favorite item from the user's list based on ID and type. Requires both the item's ID (in the URL path) and its type (in the request body).
 *
 * @tags Favorites
 * @name FavoritesDelete
 * @summary Remove a favorite item for the authenticated user
 * @request DELETE:/samples/favorites/{id}
 * @secure
 * @response `200` `{
  \** @example "Sample removed from favorites successfully" *\
    msg?: string,

}` Successfully removed the favorite item
 * @response `400` `{
  \** @example "Favorite type is missing" *\
    msg?: string,

}` Missing or invalid input
 * @response `404` `{
  \** @example "Sample not found in favorites" *\
    msg?: string,

}` Favorite item or user not found
 * @response `500` `{
  \** @example "Failed to remove Sample from favorites" *\
    error?: string,

}` Server error while removing the favorite
 */
    favoritesDelete: (
      id: string,
      data: {
        /**
         * Type of the favorite item
         * @example "SAMPLE"
         */
        type: "ALBUM" | "SAMPLE" | "FRAGMENT";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "Sample removed from favorites successfully" */
          msg?: string;
        },
        | {
            /** @example "Favorite type is missing" */
            msg?: string;
          }
        | {
            /** @example "Sample not found in favorites" */
            msg?: string;
          }
        | {
            /** @example "Failed to remove Sample from favorites" */
            error?: string;
          }
      >({
        path: `/samples/favorites/${id}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  authors = {
    /**
 * No description
 *
 * @name AuthorsCreate
 * @summary Create a new author
 * @request POST:/authors
 * @response `200` `Author` Author created
 * @response `400` `{
    error?: string,

}` Bad request (no fields provided)
 */
    authorsCreate: (
      data: {
        en?: string;
        ru?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Author,
        {
          error?: string;
        }
      >({
        path: `/authors`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthorsList
     * @summary Get all authors
     * @request GET:/authors
     * @response `200` `(Author)[]` List of authors
     */
    authorsList: (params: RequestParams = {}) =>
      this.request<Author[], any>({
        path: `/authors`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @name AuthorsPartialUpdate
 * @summary Partially update an existing author
 * @request PATCH:/authors/{id}
 * @response `200` `Author` Updated author
 * @response `400` `{
    error?: string,

}` Bad request (no fields provided)
 * @response `404` `{
    error?: string,

}` Author not found
 */
    authorsPartialUpdate: (
      id: string,
      data: {
        /** English name (optional) */
        en?: string;
        /** Russian name (optional) */
        ru?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Author,
        {
          error?: string;
        }
      >({
        path: `/authors/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  categories = {
    /**
     * No description
     *
     * @name CategoriesCreate
     * @summary Create a new category
     * @request POST:/categories
     * @response `200` `Category` Category created
     */
    categoriesCreate: (
      data: {
        en?: string;
        ru?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Category, any>({
        path: `/categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoriesList
     * @summary Get all categories
     * @request GET:/categories
     * @response `200` `(Category)[]` List of categories
     */
    categoriesList: (params: RequestParams = {}) =>
      this.request<Category[], any>({
        path: `/categories`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @name CategoriesPartialUpdate
 * @summary Partially update an existing category
 * @request PATCH:/categories/{_id}
 * @response `200` `Category` Updated category
 * @response `400` `{
    error?: string,

}` Bad request (no fields provided)
 * @response `404` `{
    error?: string,

}` Category not found
 */
    categoriesPartialUpdate: (
      id: string,
      data: {
        /** English name (optional) */
        en?: string;
        /** Russian name (optional) */
        ru?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Category,
        {
          error?: string;
        }
      >({
        path: `/categories/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  trudesk = {
    /**
 * @description Creates a new ticket with the provided details
 *
 * @tags Tickets
 * @name TicketCreate
 * @summary Create a new ticket
 * @request POST:/trudesk/ticket
 * @response `200` `{
    data?: object,

}` Ticket created successfully
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    ticketCreate: (
      data: {
        subject: string;
        issue: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        {
          /** Error message. */
          error: string;
        }
      >({
        path: `/trudesk/ticket`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Updates the details of an existing ticket
 *
 * @tags Tickets
 * @name TicketUpdate
 * @summary Update a ticket
 * @request PUT:/trudesk/ticket/{id}
 * @response `200` `{
    data?: object,

}` Ticket updated successfully
 * @response `400` `{
  \** Error message. *\
    error: string,

}` Bad request
 * @response `401` `{
  \** Error message. *\
    error: string,

}` Unauthorized
 */
    ticketUpdate: (
      id: string,
      data: {
        subject?: string;
        issue?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        {
          /** Error message. */
          error: string;
        }
      >({
        path: `/trudesk/ticket/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Uploads an image to the server
 *
 * @tags Images
 * @name ImageUploadCreate
 * @summary Upload an image
 * @request POST:/trudesk/image/upload
 * @response `200` `{
    secure_url?: string,

}` Image uploaded successfully
 * @response `400` `void` Bad request
 * @response `500` `void` Internal server error
 */
    imageUploadCreate: (
      data: {
        /** @format binary */
        image?: File;
        key?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          secure_url?: string;
        },
        void
      >({
        path: `/trudesk/image/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves a list of all tickets
 *
 * @tags Tickets
 * @name TicketsList
 * @summary Get all tickets
 * @request GET:/trudesk/tickets
 * @response `200` `(object)[]` List of tickets retrieved successfully
 * @response `400` `{
  \** Error message. *\
    error: string,

}` Bad request
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    ticketsList: (params: RequestParams = {}) =>
      this.request<
        object[],
        {
          /** Error message. */
          error: string;
        }
      >({
        path: `/trudesk/tickets`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Adds a comment to a specified ticket
 *
 * @tags Comments
 * @name TicketCommentCreate
 * @summary Add a comment to a ticket
 * @request POST:/trudesk/ticket/comment
 * @response `200` `{
    data?: object,

}` Comment added successfully
 * @response `400` `{
  \** Error message. *\
    error: string,

}` Bad request
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    ticketCommentCreate: (
      data: {
        comment?: string;
        ticketId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        {
          /** Error message. */
          error: string;
        }
      >({
        path: `/trudesk/ticket/comment`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Updates a comment on a specified ticket
 *
 * @tags Comments
 * @name TicketCommentUpdate
 * @summary Update a comment on a ticket
 * @request PUT:/trudesk/ticket/comment
 * @response `200` `{
    data?: object,

}` Comment updated successfully
 * @response `400` `{
  \** Error message. *\
    error: string,

}` Bad request
 * @response `500` `{
  \** Error message. *\
    error: string,

}` Internal server error
 */
    ticketCommentUpdate: (
      data: {
        comment?: string;
        commentId?: string;
        ticketId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: object;
        },
        {
          /** Error message. */
          error: string;
        }
      >({
        path: `/trudesk/ticket/comment`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  conferences = {
    /**
 * No description
 *
 * @tags Sessions
 * @name SessionCreate
 * @summary Create a new session
 * @request POST:/conferences/session
 * @secure
 * @response `200` `{
  \** UUID of the newly created session *\
    uuid?: string,

}` Successfully created session
 * @response `401` `void` Unauthorized request
 */
    sessionCreate: (params: RequestParams = {}) =>
      this.request<
        {
          /** UUID of the newly created session */
          uuid?: string;
        },
        void
      >({
        path: `/conferences/session`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Sessions
 * @name SessionsList
 * @summary Get all sessions
 * @request GET:/conferences/sessions
 * @secure
 * @response `200` `{
    sessions?: (string)[],

}` Successfully retrieved sessions
 * @response `401` `void` Unauthorized request
 */
    sessionsList: (params: RequestParams = {}) =>
      this.request<
        {
          sessions?: string[];
        },
        void
      >({
        path: `/conferences/sessions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sessions
     * @name GenerateQrcodeDetail
     * @summary Generate QR code for session
     * @request GET:/conferences/generate-qrcode/{uuid}
     * @secure
     * @response `200` `File` Successfully generated QR code
     * @response `404` `void` Session not found
     * @response `500` `void` Error generating QR code
     */
    generateQrcodeDetail: (uuid: string, params: RequestParams = {}) =>
      this.request<File, void>({
        path: `/conferences/generate-qrcode/${uuid}`,
        method: "GET",
        secure: true,
        format: "blob",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Phone Streaming
     * @name PhoneStreamingPageDetail
     * @summary Serve static files for phone streaming
     * @request GET:/conferences/phoneStreamingPage/{uuid}
     * @secure
     * @response `200` `string` Successfully served static files
     * @response `404` `void` Session not found
     * @response `500` `void` Error serving static files
     */
    phoneStreamingPageDetail: (uuid: string, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/conferences/phoneStreamingPage/${uuid}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags WebSocket
 * @name WebsocketsIdsDetail
 * @summary Retrieve WebSocket IDs for a conference
 * @request GET:/conferences/websocketsIds/{conferenceUUID}
 * @response `200` `{
    data?: (string)[],

}` Successful response
 * @response `404` `{
    err?: string,

}` No session found with the specified UUID
 */
    websocketsIdsDetail: (conferenceUuid: string, params: RequestParams = {}) =>
      this.request<
        {
          data?: string[];
        },
        {
          err?: string;
        }
      >({
        path: `/conferences/websocketsIds/${conferenceUuid}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  midi = {
    /**
 * @description Accepts timemap, filtered notes, note on/off events, processes the information, and returns the filtered notes along with the count of missed notes.
 *
 * @name ProcessMidiCreate
 * @summary Process MIDI information and return all filtered notes and missed notes count
 * @request POST:/midi/processMidi
 * @response `200` `{
  \** Hashmap of string to Note. *\
    notesHashMap?: object,
  \** The count of missed notes. *\
    countOfMissedNotes?: number,

}` Successfully processed the MIDI information.
 */
    processMidiCreate: (
      data: {
        /** A list of time mappings for MIDI notes. */
        timemap: object[];
        /** A list of MIDI "Note On" events. */
        noteOnEvents: object[];
        /** A list of MIDI "Note Off" events. */
        noteOffEvents: object[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Hashmap of string to Note. */
          notesHashMap?: object;
          /** The count of missed notes. */
          countOfMissedNotes?: number;
        },
        any
      >({
        path: `/midi/processMidi`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  authorize = {
    /**
 * @description This endpoint handles the authorization process. If the user is authenticated, the server redirects to the given callback URL. Otherwise, the user is redirected to the Keycloak login page.
 *
 * @name AuthorizeUser
 * @summary Handle user authorization and redirection
 * @request GET:/authorize/{callbackurl}
 * @response `200` `{
  \** The URL to which the user is redirected after authorization. *\
    redirectUrl?: string,

}` Successfully authorized and redirected to the callback URL.
 * @response `302` `{
  \** The URL to which the user is redirected for authentication. *\
    redirectUrl?: string,

}` Redirect to the Keycloak login page.
 * @response `400` `void` Missing or invalid callback URL.
 * @response `500` `void` An internal error occurred while processing the authorization request.
 */
    authorizeUser: (callbackurl: string, params: RequestParams = {}) =>
      this.request<
        {
          /** The URL to which the user is redirected after authorization. */
          redirectUrl?: string;
        },
        {
          /** The URL to which the user is redirected for authentication. */
          redirectUrl?: string;
        } | void
      >({
        path: `/authorize/${callbackurl}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  out = {
    /**
 * @description This endpoint handles the user sign-out process, clears session cookies, and destroys the session.
 *
 * @name SignOutUser
 * @summary Sign out the user and clear session cookies
 * @request POST:/out
 * @response `200` `{
  \** Success message indicating that the user has been logged out. *\
    message?: string,

}` User successfully logged out and session cleared.
 * @response `500` `{
  \** Error message indicating failure during the sign-out process. *\
    error?: string,

}` An error occurred during the sign-out process.
 */
    signOutUser: (params: RequestParams = {}) =>
      this.request<
        {
          /** Success message indicating that the user has been logged out. */
          message?: string;
        },
        {
          /** Error message indicating failure during the sign-out process. */
          error?: string;
        }
      >({
        path: `/out`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  changePassword = {
    /**
 * @description Allows the currently authenticated user to change their password.
 *
 * @name ChangePassword
 * @summary Change the user's password
 * @request POST:/change-password
 * @secure
 * @response `200` `{
  \** Success message indicating password change. *\
    message?: string,

}` Password changed successfully.
 * @response `400` `{
  \** Error message for missing or incorrect password fields. *\
    error?: string,

}` Invalid current password or missing fields.
 * @response `500` `{
  \** Error message indicating failure to change the password. *\
    error?: string,

}` Internal server error or failure to change password.
 */
    changePassword: (
      data: {
        /** The current password of the user. */
        currentPassword?: string;
        /** The new password the user wants to set. */
        newPassword?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Success message indicating password change. */
          message?: string;
        },
        | {
            /** Error message for missing or incorrect password fields. */
            error?: string;
          }
        | {
            /** Error message indicating failure to change the password. */
            error?: string;
          }
      >({
        path: `/change-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  iplogging = {
    /**
 * @description Logs comprehensive user information including IP address, user agent, headers, and authentication data to console. Fetches geolocation information from ipapi.co for the user's IP address with 24-hour caching. Only fetches new data from ipapi.co once per IP per 24 hours to avoid rate limiting.
 *
 * @tags User Management
 * @name IploggingCreate
 * @summary Log user IP information and fetch geolocation data
 * @request POST:/iplogging
 * @secure
 * @response `200` `{
  \**
   * Success message indicating the operation result
   * @example "IP info retrieved from cache"
   *\
    message: string,
  \** Geolocation information from ipapi.co *\
    ipInfo: {
  \**
   * IP address
   * @example "8.8.8.8"
   *\
    ip?: string,
  \**
   * City name
   * @example "Mountain View"
   *\
    city?: string,
  \**
   * Region/state
   * @example "California"
   *\
    region?: string,
  \**
   * Country name
   * @example "United States"
   *\
    country?: string,
  \**
   * Full country name
   * @example "United States"
   *\
    country_name?: string,
  \**
   * Latitude coordinate
   * @example 37.4056
   *\
    latitude?: number,
  \**
   * Longitude coordinate
   * @example -122.0775
   *\
    longitude?: number,
  \**
   * Timezone
   * @example "America/Los_Angeles"
   *\
    timezone?: string,
  \**
   * Organization/ISP
   * @example "Google LLC"
   *\
    org?: string,

},
  \**
   * Whether the IP info was retrieved from cache
   * @example true
   *\
    cached: boolean,
  \**
   * Timestamp of when the data was fetched or cached
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   *\
    timestamp: string,

}` IP information logged and retrieved successfully
 * @response `500` `{
  \**
   * Error message
   * @example "Internal server error"
   *\
    error: string,

}` Internal server error
 */
    iploggingCreate: (params: RequestParams = {}) =>
      this.request<
        {
          /**
           * Success message indicating the operation result
           * @example "IP info retrieved from cache"
           */
          message: string;
          /** Geolocation information from ipapi.co */
          ipInfo: {
            /**
             * IP address
             * @example "8.8.8.8"
             */
            ip?: string;
            /**
             * City name
             * @example "Mountain View"
             */
            city?: string;
            /**
             * Region/state
             * @example "California"
             */
            region?: string;
            /**
             * Country name
             * @example "United States"
             */
            country?: string;
            /**
             * Full country name
             * @example "United States"
             */
            country_name?: string;
            /**
             * Latitude coordinate
             * @example 37.4056
             */
            latitude?: number;
            /**
             * Longitude coordinate
             * @example -122.0775
             */
            longitude?: number;
            /**
             * Timezone
             * @example "America/Los_Angeles"
             */
            timezone?: string;
            /**
             * Organization/ISP
             * @example "Google LLC"
             */
            org?: string;
          };
          /**
           * Whether the IP info was retrieved from cache
           * @example true
           */
          cached: boolean;
          /**
           * Timestamp of when the data was fetched or cached
           * @format date-time
           * @example "2024-01-15T10:30:00.000Z"
           */
          timestamp: string;
        },
        {
          /**
           * Error message
           * @example "Internal server error"
           */
          error: string;
        }
      >({
        path: `/iplogging`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  avatar = {
    /**
 * @description Returns a temporary signed URL to access the avatar from private S3 bucket (expires in 1 hour).
 *
 * @tags Avatar
 * @name AvatarCreate
 * @summary Get avatar signed URL for the current logged-in user
 * @request POST:/avatar
 * @secure
 * @response `200` `{
  \**
   * Temporary signed URL to access the avatar (expires in 1 hour).
   * @example "https://s3.amazonaws.com/darpiano-private/avatars/...?X-Amz-Signature=..."
   *\
    avatarUrl: string,
  \**
   * Number of seconds until the URL expires.
   * @example 3600
   *\
    expiresIn: number,

}` Avatar signed URL returned successfully
 * @response `401` `{
  \** @example "Unauthorized" *\
    error?: string,

}` Unauthorized - user not logged in
 * @response `404` `{
  \** @example "Avatar not found" *\
    error?: string,

}` Avatar not found
 * @response `500` `void` Server error or S3 issue
 */
    avatarCreate: (
      data: {
        /**
         * Path of avatar image in S3.
         * @example "avatars/user-123-200.png"
         */
        path: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * Temporary signed URL to access the avatar (expires in 1 hour).
           * @example "https://s3.amazonaws.com/darpiano-private/avatars/...?X-Amz-Signature=..."
           */
          avatarUrl: string;
          /**
           * Number of seconds until the URL expires.
           * @example 3600
           */
          expiresIn: number;
        },
        | {
            /** @example "Unauthorized" */
            error?: string;
          }
        | {
            /** @example "Avatar not found" */
            error?: string;
          }
        | void
      >({
        path: `/avatar`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  accessToken = {
    /**
     * No description
     *
     * @name AccessTokenList
     * @summary Get new access_token
     * @request GET:/access_token
     * @response `200` `object` Successfully refreshed Cookie.
     * @response `500` `void` An internal error occurred while processing the authorization request.
     */
    accessTokenList: (params: RequestParams = {}) =>
      this.request<object, void>({
        path: `/access_token`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  report = {
    /**
     * @description Recalculates user reports based on the specified scope and threshold. Only accessible by users with the `DARPIANO_ADMIN_ROLE`.
     *
     * @tags Reports
     * @name RecalculateCreate
     * @summary Recalculate user reports.
     * @request POST:/report/recalculate
     * @response `200` `void` Reports successfully recalculated.
     * @response `403` `void` User not authorized.
     * @response `500` `void` Internal server error.
     */
    recalculateCreate: (
      data: {
        /** ID of the user for whom the report should be recalculated. Defaults to the current user. */
        targetUserId?: string;
        /**
         * Threshold in seconds to determine event groupings.
         * @example 3
         */
        targetTresholdSeconds?: number;
        /**
         * Only reports for given samples will be affected. Can also be an array string to affect multiple samples at the same time.
         * @example "identifier"
         */
        sampleId?: string;
        /** Week to start recalculation from. If timestamp corresponds to the middle of the week - first monday before this date will be user for recalculation. If not provided - all weeks will be recalculated. */
        fromWeekStartAt?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/report/recalculate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Recalculates reports for all users across the system based on the provided threshold for given samples. Only accessible by users with admin role.
     *
     * @tags Reports
     * @name RecalculateAllCreate
     * @summary Recalculate reports for all users for given samples.
     * @request POST:/report/recalculate/all
     * @response `200` `void` Successfully recalculated all reports.
     * @response `403` `void` User not authorized.
     * @response `500` `void` Internal server error.
     */
    recalculateAllCreate: (
      data: {
        /**
         * Threshold in seconds to determine event groupings.
         * @example 3
         */
        targetTresholdSeconds?: number;
        /**
         * Only reports for given samples will be affected. Can also be an array string to affect multiple samples at the same time.
         * @example "identifier"
         */
        sampleId?: string;
        /** Week to start recalculation from. If timestamp corresponds to the middle of the week - first monday before this date will be user for recalculation. If not provided - all weeks will be recalculated. */
        fromWeekStartAt?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/report/recalculate/all`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Processes single or bulk key events and updates user reports accordingly. The timestamp is either provided by the client or defaults to the current time.
     *
     * @tags Key Events
     * @name KeyeventUpdate
     * @summary Process key events.
     * @request PUT:/report/keyevent
     * @response `200` `void` Successfully processed key event(s).
     * @response `400` `void` Invalid timestamp provided.
     * @response `500` `void` Unable to process key event(s).
     */
    keyeventUpdate: (
      data: {
        events?: {
          /** Event timestamp. */
          timestamp?: number;
        }[];
        /** Single event timestamp if not using bulk processing. */
        timestamp?: number;
        /**
         * Sample identifier to whom event is related.
         * @example "identifier"
         */
        sampleId?: string;
        /** ID of the user to process events for. Defaults to the current user. */
        targetUserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/report/keyevent`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * @description Retrieves the report for the user specified by the UUID. Defaults to the current user's report if UUID is not provided.
 *
 * @tags Reports
 * @name SampleDetail
 * @summary Retrieve user report.
 * @request GET:/report/{uuid}/sample/{sampleId}
 * @response `200` `{
    userReport?: {
    accumulatedTime?: number,

},

}` Successfully retrieved user report.
 * @response `404` `void` User report not found.
 * @response `500` `void` Internal server error.
 */
    sampleDetail: (uuid: string, sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          userReport?: {
            accumulatedTime?: number;
          };
        },
        void
      >({
        path: `/report/${uuid}/sample/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves the report for current user.
 *
 * @tags Reports
 * @name SampleDetail2
 * @summary Retrieve report for current user.
 * @request GET:/report/sample/{sampleId}
 * @originalName sampleDetail
 * @duplicate
 * @response `200` `{
    userReport?: {
    accumulatedTime?: number,

},

}` Successfully retrieved user report.
 * @response `404` `void` User report not found.
 * @response `500` `void` Internal server error.
 */
    sampleDetail2: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          userReport?: {
            accumulatedTime?: number;
          };
        },
        void
      >({
        path: `/report/sample/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes reports for the specified user. Can target either current week's reports or all reports. Only accessible by users with the `DARPIANO_ADMIN_ROLE`.
     *
     * @tags Reports
     * @name ReportDelete
     * @summary Delete user reports.
     * @request DELETE:/report/
     * @response `200` `void` Successfully deleted reports.
     * @response `403` `void` User not authorized.
     * @response `500` `void` Internal server error.
     */
    reportDelete: (
      data: {
        /** ID of the user whose reports should be deleted. Defaults to the current user. */
        targetUserId?: string;
        /** Whether to delete only the current week's reports. */
        onlyCurrentWeek?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/report/`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * @description Collects all events for given parameters and dynamically generates report based on them.
 *
 * @tags Reports
 * @name GenerateCreate
 * @summary Dynamically generate report for given user.
 * @request POST:/report/generate/{uuid}
 * @response `200` `{
    report?: {
    accumulatedTime?: number,

},

}` Successfully retrieved user report.
 * @response `404` `void` User report not found.
 * @response `500` `void` Internal server error.
 */
    generateCreate: (
      uuid: string,
      data: {
        /** ID of the user for whom the report should be recalculated. Defaults to the current user. */
        targetUserId?: string;
        /**
         * Threshold in seconds to determine event groupings.
         * @example 3
         */
        targetTresholdSeconds?: number;
        /**
         * Only reports for given samples will be affected. Can also be an array string to affect multiple samples at the same time.
         * @example "identifier"
         */
        sampleId?: string;
        /** If true - will generate an array in return, corresponding for each week. If false - will generate a single report starting from fromTimestamp param. */
        byWeeks?: boolean;
        /** Timestamp starting from which events will be counted. Will NOT default to monday. If left empty current timestamp will be used. */
        fromTimestamp?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          report?: {
            accumulatedTime?: number;
          };
        },
        void
      >({
        path: `/report/generate/${uuid}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  fragments = {
    /**
 * No description
 *
 * @name FragmentsDetail
 * @summary Get all fragments for sample
 * @request GET:/fragments/{sampleId}
 * @response `200` `{
    fragments?: ({
    name?: string,
    sampleId?: string,
    range?: {
    startCoord?: Coord,
    endCoord?: Coord,

},
    hand?: "left" | "right",
    _id?: string,
    uuid?: string,

})[],

}` Successfully retrieved fragments.
 * @response `500` `void` An internal error occurred.
 */
    fragmentsDetail: (sampleId: string, params: RequestParams = {}) =>
      this.request<
        {
          fragments?: {
            name?: string;
            sampleId?: string;
            range?: {
              startCoord?: Coord;
              endCoord?: Coord;
            };
            hand?: "left" | "right";
            _id?: string;
            uuid?: string;
          }[];
        },
        void
      >({
        path: `/fragments/${sampleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FragmentsCreate
     * @summary Create new fragment for sample
     * @request POST:/fragments/{sampleId}
     * @response `200` `void` Successfully created new fragment.
     * @response `400` `void` Input data invalid.
     * @response `500` `void` An internal error occurred.
     */
    fragmentsCreate: (
      sampleId: string,
      data: {
        name?: string;
        hand?: "left" | "right";
        range?: {
          startCoord?: Coord;
          endCoord?: Coord;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/fragments/${sampleId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name FragmentsDelete
     * @summary Delete existing fragment
     * @request DELETE:/fragments/{fragmentId}
     * @response `200` `void` Successfully deleted fragment.
     * @response `500` `void` An internal error occurred.
     */
    fragmentsDelete: (fragmentId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/fragments/${fragmentId}`,
        method: "DELETE",
        ...params,
      }),
  };
}
